// Mock data for initial frontend implementation

import standardImage1 from '../Assests/standard/4.jpeg';
import standardImage2 from '../Assests/standard/5.jpeg';
import standardImage3 from '../Assests/standard/8.jpeg';
import standardImage4 from '../Assests/standard/12.jpeg';


import commercialImage1 from '../Assests/commercial/2.jpeg';
import commercialImage2 from '../Assests/commercial/3.jpeg';
import commercialImage3 from '../Assests/commercial/9.jpeg';
import commercialImage4 from '../Assests/commercial/14.jpeg';

import deepImage1 from '../Assests/deep/1.jpeg';
import deepImage2 from '../Assests/deep/8.jpeg';
import deepImage3 from '../Assests/deep/13.jpeg';

import vacateImage1 from '../Assests/vacate/1.jpeg';
import vacateImage2 from '../Assests/vacate/2.jpeg';
import vacateImage4 from '../Assests/vacate/4.jpeg';

import plasureWash from '../Assests/serviceCategory/2.jpeg';
import carpetImages from '../Assests/serviceCategory/1.jpeg';
import tileCategory from '../Assests/serviceCategory/3.jpeg';
import hardfloor from '../Assests/serviceCategory/4.jpeg';



export const services = [
  {
    id: 'standard',
    name: 'Standard Cleaning',
    tagline: 'Ideal for home maintenance and upkeep',
    description: 'Our standard cleaning service covers all the essential daily cleaning tasks to keep your home fresh and tidy.',
    image: [standardImage1, standardImage3, standardImage2, standardImage4],
    features: [
      'Ideal for home maintenance and upkeep',
      'Covers daily cleaning tasks',
      'Available once-off or on a recurring basis'
    ],
    popular: false
  },
  {
    id: 'commercial',
    name: 'Commercial Cleaning',
    tagline: 'Professional cleaning for businesses',
    description: 'Ideal for regular schedules, special events, office moves or once-off cleans.',
    image: [commercialImage1, commercialImage2, commercialImage3, commercialImage4],
    features: [
      'Ideal for regular schedules, special events, office moves or once-off cleans',
      'Includes general cleaning, restroom cleaning and more',
      'Carpet steam cleaning',
      'Tile & grout cleaning',
      'Hard floors maintenance',
      'Pressure washing',
      'Quote provided after a site visit with no additional fees',
      'Fully customizable'
    ],
    popular: false
  },
 
  {
    id: 'deep',
    name: 'Deep Cleaning',
    tagline: 'A comprehensive and meticulous cleaning',
    description: 'Perfect for difficult cleaning tasks such as cleaning ovens, window interiors and more.',
    image: [deepImage1, deepImage2, deepImage3],
    features: [
      'A comprehensive and meticulous cleaning',
      'Perfect for difficult cleaning tasks such as cleaning ovens, window interiors and more',
      'Available once-off or on a recurring basis'
    ],
    popular: true
  },
  {
    id: 'vacate',
    name: 'Vacate Cleaning',
    tagline: 'Bond Back Guarantee',
    description: 'Perfect for when you are moving out or if you want a new home freshly cleaned.',
    image: [vacateImage1, vacateImage2, vacateImage4],
    features: [
      'Perfect for when you are moving out or if you want a new home freshly cleaned',
      'Includes a Bond Back Guarantee',
      'Fully customizable'
    ],
    popular: false
  }
  ,
  {
    id: 'pressure-washing',
    name: 'Pressure Washing',
    tagline: 'Restore Surfaces to Like-New Condition',
    description: 'High-pressure cleaning to remove dirt, mould, and stains from outdoor and hard surfaces.',
    image: [plasureWash],
    features: [
      'Ideal for driveways, patios, walls, and pathways',
      'Removes mould, algae, dirt, and built-up grime',
      'Enhances appearance and extends surface lifespan'
    ],
    popular: false
  },
  {
    id: 'carpet-upholstery-steam-cleaning',
    name: 'Carpet & Upholstery Steam Cleaning',
    tagline: 'Deep Clean for a Healthier Home',
    description: 'Professional steam cleaning to remove deep dirt, allergens, and stains from carpets and furniture.',
    image: [carpetImages],
    features: [
      'Deep steam cleaning for carpets and upholstery',
      'Eliminates stains, odours, and allergens',
      'Safe for families, pets, and all fabric types'
    ],
    popular: false
  },
  {
    id: 'tile-grout-cleaning',
    name: 'Tile & Grout Cleaning',
    tagline: 'Bring Back the Original Shine',
    description: 'Specialised cleaning to remove stubborn dirt and stains from tiles and grout lines.',
    image: [tileCategory],
    features: [
      'Restores tiles and grout to their original look',
      'Removes mould, grease, and deep-set dirt',
      'Suitable for kitchens, bathrooms, and floors'
    ],
    popular: false
  },
  {
    id: 'hard-floor-maintenance',
    name: 'Hard Floor Maintenance',
    tagline: 'Protect and Maintain Your Floors',
    description: 'Professional care and maintenance to keep hard floors clean, polished, and long-lasting.',
    image: [hardfloor],
    features: [
      'Cleaning and maintenance for all hard floor types',
      'Enhances durability and appearance',
      'Custom solutions based on floor material'
    ],
    popular: false
  }
  
];

export const trustReasons = [
  {
    title: 'Equipped',
    description: 'Eco friendly chemicals.',
    icon: 'Tool'
  },
  {
    title: 'Police Checked',
    description: 'Police cleared personnels.',
    icon: 'ShieldCheck'
  },
  {
    title: 'Insured',
    description: 'Public liability insured.',
    icon: 'Shield'
  },
  {
    title: 'Experienced',
    description: 'We ensure that all cleaning staff have years of experience.',
    icon: 'Award'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Get an instant quote',
    description: 'Find your customized quote instantly by completing the booking form.',
    icon: 'Calculator'
  },
  {
    step: 2,
    title: 'Complete your booking',
    description: 'Customize your cleaning service request according to your needs and enjoy a fast check-out process.',
    icon: 'Calendar'
  },
  {
    step: 3,
    title: 'Experience the cleaning magic',
    description: 'Relax as our experienced cleaning professional cleans your space for you on your selected schedule.',
    icon: 'Sparkles'
  },
  {
    step: 4,
    title: 'Leave a review',
    description: 'If you are happy with our service, provide feedback and receive a discount for your next home clean!',
    icon: 'Star'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Dinu S',
    rating: 5,
    date: '1 days ago',
    text: 'Really impressed with the cleaning service! My gas oven was cleaned thoroughly and looks as good as new. Highly recommended.',
    avatar: 'https://ui-avatars.com/api/?name=Caimen+Potts&background=4285f4&color=fff'
  }
];

export const faqs = [
  {
    question: 'How do I book?',
    answer: 'Booking a cleaning service with Royal Shine is quick and easy! You can book through our website by filling out our online booking form, or you can give us a call or send us an email to schedule your appointment. Our friendly team will be happy to assist you in selecting a convenient date and time for your cleaning service.'
  },
  {
    question: 'How long does a clean take?',
    answer: 'The duration of a cleaning service can vary depending on the amount of time booked or size of your property. Our booking form gives you the choice to book by duration if you have specific areas you need to focus on or you can book by house size if you want the entire home cleaned.'
  },
  {
    question: 'How many people will come to clean?',
    answer: 'We are happy to cater for you! If you would like a smaller or larger team, please let us know prior to job commencement. If no preference is provided, the team assigned and their size is based on availability.'
  },
  {
    question: 'What if I am unhappy with the clean?',
    answer: 'At Royal Shine, we take customer satisfaction seriously, and if you are unhappy with any aspect of our cleaning service, we encourage you to contact us immediately. Our team is committed to resolving any issues and ensuring that you are completely satisfied with our service.'
  },
  {
    question: 'What areas do you service?',
    answer: 'We provide cleaning services across Perth and surrounding suburbs. Contact us to confirm if we service your area.'
  },
  {
    question: 'Do I need to provide cleaning supplies?',
    answer: 'No! Our cleaners come fully equipped with all necessary cleaning supplies and equipment. However, if you have specific products you\'d like us to use, we\'re happy to accommodate.'
  }
];

export const comparisonData = [
  {
    category: 'Cleaning Tasks (All Rooms)',
    tasks: [
      { name: 'Vacuuming', standard: true, deep: true },
      { name: 'Mopping', standard: true, deep: true },
      { name: 'Emptying bins', standard: true, deep: true },
      { name: 'Wiping surfaces', standard: true, deep: true }
    ]
  },
  {
    category: 'Surfaces & Fixtures (All Rooms)',
    tasks: [
      { name: 'Skirting Boards', standard: false, deep: true },
      { name: 'Ceiling Fans', standard: false, deep: true },
      { name: 'Shelves', standard: true, deep: true },
      { name: 'Outside Cabinets', standard: true, deep: true },
      { name: 'Inside Cabinets', standard: false, deep: true },
      { name: 'Blinds', standard: false, deep: true },
      { name: 'Inside Windows and Tracks', standard: false, deep: true },
      { name: 'Wall Marks', standard: false, deep: true },
      { name: 'Exhaust Fans', standard: false, deep: true }
    ]
  },
  {
    category: 'Kitchen / Living',
    tasks: [
      { name: 'Washing Up', standard: true, deep: true },
      { name: 'Stove Top', standard: true, deep: true },
      { name: 'Microwave', standard: true, deep: true },
      { name: 'Sinks', standard: true, deep: true },
      { name: 'Countertops', standard: true, deep: true },
      { name: 'Inside Microwave', standard: false, deep: true },
      { name: 'Inside Oven', standard: false, deep: true }
    ]
  },
  {
    category: 'Bathroom / Laundry',
    tasks: [
      { name: 'Toilet', standard: true, deep: true },
      { name: 'Shower / Bath', standard: true, deep: true },
      { name: 'Sinks', standard: true, deep: true },
      { name: 'Mirrors', standard: true, deep: true }
    ]
  }
];

export const pricingConfig = {
  baseRates: {
    standard: {
      hourly: 60,
      rates: {
        "1_1": { onceOff: 120, weekly: 108, fortnightly: 108, monthly: 114 },
        "2_1": { onceOff: 150, weekly: 135, fortnightly: 135, monthly: 143 },
        "3_1": { onceOff: 210, weekly: 189, fortnightly: 189, monthly: 200 },
        "4_1": { onceOff: 270, weekly: 243, fortnightly: 243, monthly: 257 },
        "5_1": { onceOff: 330, weekly: 297, fortnightly: 297, monthly: 314 },

        "2_2": { onceOff: 180, weekly: 162, fortnightly: 162, monthly: 171 },
        "3_2": { onceOff: 240, weekly: 216, fortnightly: 216, monthly: 228 },
        "4_2": { onceOff: 300, weekly: 270, fortnightly: 270, monthly: 285 },
        "5_2": { onceOff: 360, weekly: 324, fortnightly: 324, monthly: 342 },

        "3_3": { onceOff: 270, weekly: 243, fortnightly: 243, monthly: 257 },
        "4_3": { onceOff: 330, weekly: 297, fortnightly: 297, monthly: 314 },
        "5_3": { onceOff: 390, weekly: 351, fortnightly: 351, monthly: 371 }
      }
    },

    deep: {
      hourly: 80,
      rates: {
        "1_1": 320,
        "2_1": 400,
        "3_1": 520,
        "4_1": 600,
        "5_1": 680,

        "2_2": 480,
        "3_2": 560,
        "4_2": 640,
        "5_2": 720,

        "3_3": 600,
        "4_3": 680,
        "5_3": 720
      }
    },

    vacate: {
      hourly: 90,
      rates: {
        noCarpet: {
          "1_1": 360,
          "2_1": 450,
          "3_1": 585,
          "4_1": 675,
          "5_1": 765,

          "2_2": 540,
          "3_2": 630,
          "4_2": 720,
          "5_2": 810,

          "3_3": 675,
          "4_3": 765,
          "5_3": 810
        },
        withCarpet: {
          "1_1": 450,
          "2_1": 550,
          "3_1": 700,
          "4_1": 800,
          "5_1": 900,

          "2_2": 650,
          "3_2": 750,
          "4_2": 850,
          "5_2": 950,

          "3_3": 800,
          "4_3": 900,
          "5_3": 1000
        }
      }
    }
  }
};